import { ICashDepositItem } from 'features/cashier/components/CashDeposit/types';
import { createAction, createAsyncAction } from 'services/actionConfigs';
import {
  IProductCategoryItem,
  IProductItemData,
} from 'services/shop/types/product';
import { ISimpleMenuServiceItem } from 'services/shop/types/simpleMenu';
import { IStaffAvailableItem } from 'services/shop/types/staff';
import { IProductVIPItemData } from 'services/shop/types/vip';
import { Message } from 'stompjs';
import { FEATURE_PRODUCT_MODE, PREFIX_ACTIONS } from './constants';
import {
  ICategory,
  ICreateCustomerBody,
  IServiceCategory,
  IStaff,
} from './types/api';
import { ICustomerResItem } from './types/customer';
import { IStateDiscountItemValue } from './types/discount';
import { IGiftCardResult } from './types/giftCard';
import { IDraftQuickPayItem, IDraftSupplyFeeItemValue } from './types/quickpay';
import { IState } from './types/reducer';

const initData = createAction(PREFIX_ACTIONS + 'initData');
const getDetail = createAsyncAction<string>(PREFIX_ACTIONS + 'getDetail');

// actions init data
const getTicketDetails = createAsyncAction<string>(
  PREFIX_ACTIONS + 'getTicketDetails'
);
const updateBillIdDetails = createAction<string>(
  PREFIX_ACTIONS + 'updateBillIdDetails'
);
const addNewCustomer = createAsyncAction<ICreateCustomerBody>(
  PREFIX_ACTIONS + 'addNewCustomer'
);

// actions handle data UI   
const selectServiceItem = createAction<IServiceCategory>(
  PREFIX_ACTIONS + 'selectServiceItem'
);
const selectSimpleMenuServiceItem = createAction<ISimpleMenuServiceItem>(
  PREFIX_ACTIONS + 'selectSimpleMenuServiceItem'
);
const selectProductItem = createAction<IProductItemData>(
  PREFIX_ACTIONS + 'selectProductItem'
);
const selectProductVIPItem = createAction<IProductVIPItemData>(
  PREFIX_ACTIONS + 'selectProductVIPItem'
);

const addStaffItem = createAction<IStaff>(PREFIX_ACTIONS + 'addStaffItem');
const switchStaffItem = createAction<string>(
  PREFIX_ACTIONS + 'switchStaffItem'
);
const removeStaffItem = createAction<string>(
  PREFIX_ACTIONS + 'removeStaffItem'
);
const removeServiceOfItem = createAction<{
  staffId: string;
  serviceId?: string;
}>(PREFIX_ACTIONS + 'removeServiceOfItem');
const removeComboItem = createAction<{
  staffId: string;
  comboId: string;
}>(PREFIX_ACTIONS + 'removeComboItem');
const setActiveStaffId = createAction<string>(
  PREFIX_ACTIONS + 'setActiveStaffId'
);
const setActiveItemsCollapse = createAction<string[]>(
  PREFIX_ACTIONS + 'setActiveItemsCollapse'
);
const switchSelectedCustomer = createAction<ICustomerResItem>(
  PREFIX_ACTIONS + 'switchSelectedCustomer'
);
const removeSelectedCustomer = createAction(
  PREFIX_ACTIONS + 'removeSelectedCustomer'
);
const calculateTicketPaymentInfo = createAction(
  PREFIX_ACTIONS + 'calculateTicketPaymentInfo'
);
const setVisibleChooseCustomer = createAction<boolean>(
  PREFIX_ACTIONS + 'setVisibleChooseCustomer'
);
const setVisibleVIP = createAction<boolean>(PREFIX_ACTIONS + 'setVisibleVIP');
const setVisibleChooseStaff = createAction<IState['visibleChooseStaff']>(
  PREFIX_ACTIONS + 'setVisibleChooseStaff'
);
const setVisibleModalWarningEmptyServices = createAction<
  IState['visibleModalWarningEmptyServices']
>(PREFIX_ACTIONS + 'setVisibleModalWarningEmptyServices');
const setVisibleModalWarningConsentForm = createAction<
  IState['visibleModalWarningConsentForm']
>(PREFIX_ACTIONS + 'setVisibleModalWarningConsentForm');
const setVisibleModalWarningVIPPackage = createAction<
  IState['visibleModalWarningVIPPackage']
>(PREFIX_ACTIONS + 'setVisibleModalWarningVIPPackage');
const clearTicket = createAction(PREFIX_ACTIONS + 'clearTicket');
const setDraftStaffForNewTicket = createAction<IStaffAvailableItem>(
  PREFIX_ACTIONS + 'setDraftStaffForNewTicket'
);

// check-in
const selectCategory = createAction<ICategory>(
  PREFIX_ACTIONS + 'selectCategory'
);
const selectProductCategory = createAction<IProductCategoryItem>(
  PREFIX_ACTIONS + 'selectProductCategory'
);
const selectServiceItemAtCheckIn = createAction<IServiceCategory>(
  PREFIX_ACTIONS + 'selectServiceItemAtCheckIn'
);

const initCategories = createAction(PREFIX_ACTIONS + 'initCategories');
const setTip = createAction<number>(PREFIX_ACTIONS + 'setTip');

const setDraftServiceSwitchStaff = createAction<string | null>(
  PREFIX_ACTIONS + 'setDraftServiceSwitchStaff'
);

const setDraftQuickPay = createAction<IDraftQuickPayItem | null>(
  PREFIX_ACTIONS + 'setDraftQuickPay'
);
const updateQuickPayItem = createAction<IDraftQuickPayItem>(
  PREFIX_ACTIONS + 'updateQuickPayItem'
);

const switchStaffNew = createAction<{ newStaff: IStaff; currStaffId: string }>(
  PREFIX_ACTIONS + 'switchStaffNew'
);

const toggleVisibleDiscountItemMode = createAction(
  PREFIX_ACTIONS + 'toggleVisibleDiscountItemMode'
);

const toggleVisibleDeleteItemMode = createAction(
  PREFIX_ACTIONS + 'toggleVisibleDeleteItemMode'
);

const setDiscountTicket = createAction<IState['discountTicket']>(
  PREFIX_ACTIONS + 'setDiscountTicket'
);

const setDraftDiscountItemModal = createAction<
  IState['draftDiscountItemModal']
>(PREFIX_ACTIONS + 'setDraftDiscountItemModal');


const toggleVisibleSupplyFeeMode = createAction(
  PREFIX_ACTIONS + 'toggleVisibleSupplyFeeMode'
);

const setDraftSupplyFeeItemModal = createAction<
  IState['draftSupplyFeeItemModal']
>(PREFIX_ACTIONS + 'setDraftSupplyFeeItemModal');

const updateSupplyFeeItem = createAction<IDraftSupplyFeeItemValue>(
  PREFIX_ACTIONS + 'updateSupplyFeeItem'
);

const setDiscountItem = createAction<IStateDiscountItemValue>(
  PREFIX_ACTIONS + 'setDiscountItem'
);

const addQuickPay = createAction<{ price: number; name: string }>(
  PREFIX_ACTIONS + 'addQuickPay'
);

const addGiftCard = createAction<IGiftCardResult>(
  PREFIX_ACTIONS + 'addGiftCard'
);

const setFeatureProductMode = createAction<FEATURE_PRODUCT_MODE>(
  PREFIX_ACTIONS + 'setFeatureProductMode'
);

const activeQuickMenu = createAction<boolean>(
  PREFIX_ACTIONS + 'activeQuickMenu'
);

const clearCustomer = createAsyncAction(PREFIX_ACTIONS + 'clearCustomer');

const checkCustomerPackage = createAsyncAction<string>(
  PREFIX_ACTIONS + 'checkCustomerPackage'
);

const setEnableCardFee = createAction<boolean>(
  PREFIX_ACTIONS + 'setEnableCardFee'
);

const setVisibleCashierConfirmUpdate = createAction<boolean>(
  PREFIX_ACTIONS + 'setVisibleCashierConfirmUpdate'
);
const checkCashierWillUnmount = createAction(
  PREFIX_ACTIONS + 'checkCashierWillUnmount'
);

const setHighlightItemId = createAction<string>(
  PREFIX_ACTIONS + 'setHighlightItemId'
);

const getCustomerReferral = createAction<{
  customerId: string;
  phoneReferral: string;
}>(PREFIX_ACTIONS + 'getCustomerReferral');

const updateStaffTurnStatus = createAsyncAction<
  { staffId: string; billId: string; finishTurn: boolean },
  string
>(PREFIX_ACTIONS + 'updateStaffTurnStatus');

const syncCustomerConsentFrontSocket = createAsyncAction<Message['body']>(
  PREFIX_ACTIONS + 'syncCustomerConsentFrontSocket'
);

const setConsentMsg = createAsyncAction<Message['body']>(PREFIX_ACTIONS + 'CONSENT' + 'setConsentMsg');

const getCashDeposit = createAsyncAction<undefined, ICashDepositItem[]>(PREFIX_ACTIONS + 'getCashDeposit');

const setDraftComboSwitchStaff = createAction<{ staffId: string; comboId: string }>(PREFIX_ACTIONS + 'setDraftComboSwitchStaff');

const cashierActions = {
  getCashDeposit,

  getDetail,
  initData,

  getTicketDetails,
  addNewCustomer,

  selectCategory,
  selectProductCategory,
  selectServiceItem,
  addStaffItem,
  removeStaffItem,
  switchStaffItem,
  switchStaffNew,
  clearTicket,

  switchSelectedCustomer,
  removeSelectedCustomer,

  removeServiceOfItem,
  setActiveStaffId,
  selectServiceItemAtCheckIn,
  initCategories,
  setActiveItemsCollapse,

  calculateTicketPaymentInfo,
  setTip,
  setVisibleChooseCustomer,
  setVisibleVIP,
  setVisibleChooseStaff,
  setDraftServiceSwitchStaff,
  toggleVisibleDiscountItemMode,
  toggleVisibleDeleteItemMode,
  setDiscountTicket,
  setDraftDiscountItemModal,
  setDiscountItem,
  addQuickPay,
  addGiftCard,
  setDraftStaffForNewTicket,

  selectProductItem,
  selectSimpleMenuServiceItem,

  setFeatureProductMode,

  selectProductVIPItem,

  setVisibleModalWarningEmptyServices,
  setVisibleModalWarningConsentForm,
  setVisibleModalWarningVIPPackage,
  setDraftQuickPay,
  updateQuickPayItem,
  clearCustomer,
  checkCustomerPackage,
  setEnableCardFee,
  setVisibleCashierConfirmUpdate,
  checkCashierWillUnmount,
  setHighlightItemId,
  updateBillIdDetails,
  activeQuickMenu,

  toggleVisibleSupplyFeeMode,
  setDraftSupplyFeeItemModal,
  updateSupplyFeeItem,
  getCustomerReferral,
  updateStaffTurnStatus,
  syncCustomerConsentFrontSocket,
  setConsentMsg,
  setDraftComboSwitchStaff,
  removeComboItem,
};

export default cashierActions;
